/**
 * @desc 获取签署合同连接
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.PurchaseAgreementUrlResponseDto>;
export function request(pono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/purchaseOrder/getSignAgreementUrl/${pono}`, {
      method: "GET",

      ...options,
    }),
  );
}
